(() => {
  class SMainProduct extends HTMLElement {
    constructor() {
      super();
      this.sectionUpdate = this.sectionUpdate.bind(this);
      this._subs = [];
      this._contentBtns = [];
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this._bindContentButtons();

      if (window.PubSub && typeof window.PubSub.subscribe === 'function') {
        // subscribe to "variant:update" published by c-variant-picker
        this._subs.push(window.PubSub.subscribe('variant:update', this.sectionUpdate));
      }
    }

    disconnectedCallback() {
      this._unbindContentButtons();
      if (window.PubSub && typeof window.PubSub.unsubscribe === 'function') {
        this._subs.forEach(id => window.PubSub.unsubscribe(id));
      }
      this._subs = [];
    }

    _bindContentButtons() {
      this._contentBtns = Array.from(this.querySelectorAll('.js-main-product__content-wrapper'));

      this._contentBtns.forEach((el) => {
        const handler = () => {
          const title = el.dataset.title || '';
          const contentEl = el.querySelector('.js-main-product__content-text');
          const contentHTML = contentEl ? contentEl.innerHTML : '';

          // Prefer PubSub modal (your new system)
          if (window.PubSub && typeof window.PubSub.publish === 'function') {
            window.PubSub.publish('content-modal:open', { title, content: contentHTML });
            return;
          }

          // Fallback for older modal API (if exists)
          if (window.PURRZ && typeof window.PURRZ.openModal === 'function') {
            window.PURRZ.openModal(title, contentHTML);
          }
        };

        el.__purrClick__ = handler;
        el.addEventListener('click', handler);
      });
    }

    _unbindContentButtons() {
      this._contentBtns.forEach((el) => {
        if (el.__purrClick__) {
          try { el.removeEventListener('click', el.__purrClick__); } catch(_) {}
          delete el.__purrClick__;
        }
      });
      this._contentBtns = [];
    }

    async sectionUpdate(url) {
      try {
        this.classList.add('is-loading');
        const res = await fetch(`${url}&section_id=${this.sectionId}`);
        const html = await res.text();

        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        const next = wrap.querySelector('s-main-product'); // only inner content
        this._unbindContentButtons();

        if (next) {
          this.innerHTML = next.innerHTML;
        }

        this._bindContentButtons();
        window.history.pushState({}, '', url);
      } catch (e) {
        console.error('[s-main-product] update failed:', e);
      } finally {
        this.classList.remove('is-loading');

        // 🔔 Tell all dynamic components to (re)init on the new DOM
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: this.sectionId, target: this }
        }));

        // Fallback manual kick for our gallery init (in case no listener above)
        if (window.PurrGallery && typeof window.PurrGallery.scan === 'function') {
          window.PurrGallery.scan(this);
        }
        var items = document.querySelectorAll(".c-variant-picker__cell .c-variant-picker__item");
        if (!items || items.length === 0) return;
        items.forEach(function (item) {
            item.addEventListener("click", function () {
              setTimeout(handleVariantSelection, 1500);
            });
        });
      }
    }
  }

  if (!customElements.get('s-main-product')) {
    customElements.define('s-main-product', SMainProduct);
  }
})();
